import React from 'react';
import { NavLink } from "react-router-dom";
import '../../cssFiles/header.scss';

const Header = () => {
  const device = window.innerWidth <= 500 ? 'mobile' : 'desktop';

  return (
    <header className="nvz-header">
      <div className="nvz-logo-section">
        <NavLink to="/" className="nvz-logo-link">
          <img src='/images/header-logo.png' alt='Niveza logo' />
        </NavLink>
      </div>
      <nav className="nvz-nav">
        <NavLink to="/research">Research</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/reviews">Reviews</NavLink>
        <NavLink to="/about">{device === 'desktop' ? 'About Us' : 'About'}</NavLink>
        <NavLink to="/contact">{device === 'desktop' ? 'Contact Us' : 'Contact'}</NavLink>
      </nav>
    </header>
  );
};

export default Header;